import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { VISITS_MODULE } from '../../configs/moduleNames';

export const LOAD_VISIT_LIST = '_LOAD_VISIT_LIST';
export const LOAD_VISIT_BY_ID = '_LOAD_VISIT_BY_ID';
export const EXPORT_VISIT = '_EXPORT_VISIT';

export const loadVisitsList = createDeferredAction(VISITS_MODULE + LOAD_VISIT_LIST);
export const loadVisitsListSuccessful = createAction(VISITS_MODULE + LOAD_VISIT_LIST + SUCCESSFUL);
export const loadVisitsListFailed = createAction(VISITS_MODULE + LOAD_VISIT_LIST + FAILED);
export const loadVisitsListBegin = createAction(VISITS_MODULE + LOAD_VISIT_LIST + BEGIN);

export const loadVisitsById = createDeferredAction(VISITS_MODULE + LOAD_VISIT_BY_ID);
export const loadVisitsByIdSuccessful = createAction(VISITS_MODULE + LOAD_VISIT_BY_ID + SUCCESSFUL);
export const loadVisitsByIdFailed = createAction(VISITS_MODULE + LOAD_VISIT_BY_ID + FAILED);

export const exportVisit = createDeferredAction(VISITS_MODULE + EXPORT_VISIT);
export const exportVisitSuccessful = createAction(VISITS_MODULE + EXPORT_VISIT + SUCCESSFUL);
export const exportVisitFailed = createAction(VISITS_MODULE + EXPORT_VISIT + FAILED);
